import { Chip, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';

type ActivityChipProps = {
  label: string;
  icon: JSX.Element;
  active: boolean;
  linkPath?: string;
  onClick?: () => void;
};
const ActivityChip: React.FC<ActivityChipProps> = ({
  label,
  icon,
  active,
  linkPath,
  onClick = undefined,
}) => {
  if (linkPath) {
    return (
      <Link to={linkPath}>
        <InnerChip
          label={label}
          icon={icon}
          active={active}
        />
      </Link>
    );
  }

  return (
    <InnerChip
      label={label}
      icon={icon}
      active={active}
      onClick={onClick}
    />
  );
};

type InnerChipProps = {
  label: string;
  icon: JSX.Element;
  active: boolean;
  onClick?: () => void;
};

const InnerChip: React.FC<InnerChipProps> = ({ label, icon, active, onClick }) => {
  const theme = useTheme();
  const chipColor = active ? theme.palette.orange[900] : theme.palette.blueGrey[600];
  const chipBorderColor = active ? theme.palette.warning.main : theme.palette.blueGrey[600];
  const chipIconColor = active ? theme.palette.warning.dark : theme.palette.blueGrey[600];

  return (
    <Chip
      variant="outlined"
      label={label}
      sx={{
        px: '8px',
        color: chipColor,
        borderColor: chipBorderColor,
        backgroundColor: theme.palette.background.default,
        '& .MuiChip-icon': {
          marginRight: '6px',
          marginLeft: 0,
          color: chipIconColor,
        }
      }}
      icon={icon}
      onClick={onClick}
    />
  );
};

export default ActivityChip;
